var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var SvgEvolvingRegionsLogo = function SvgEvolvingRegionsLogo(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 202.05 121.83",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: -14.39,
    y1: -4.14,
    x2: 119.77,
    y2: 126.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#00a9e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#14a9d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#4ea7bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#80a6a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#a8a594"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#c8a486"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#dfa37c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#eca376"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f1a374"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 29.48,
    y1: -49.18,
    x2: 163.65,
    y2: 81.5,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 37.34,
    y1: -57.24,
    x2: 171.5,
    y2: 73.44,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: -20.27,
    y1: 1.9,
    x2: 113.9,
    y2: 132.57,
    xlinkHref: "#a"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Ebene 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.67 53.65V.39h33.86v6.8H8.93v15.89H30.5v6.79H8.93v17h25.6v6.79Z",
    style: {
      fill: "url(#a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171 101.19v20.56h-8.22V68.49h20.3q8.66 0 12.94 3.49t4.29 11.08v3.08A12.11 12.11 0 0 1 197.8 94a14.74 14.74 0 0 1-7.09 4.6 16.81 16.81 0 0 1 2.76 1.44 8.39 8.39 0 0 1 2 1.85 9.64 9.64 0 0 1 1.38 2.54 19.56 19.56 0 0 1 .89 3.45l1.41 6.76a10.86 10.86 0 0 0 .47 2c.22.67.46 1.31.72 1.93a17.66 17.66 0 0 0 1.71 3.17h-8.54a7.72 7.72 0 0 1-.65-1 19.196 19.196 0 0 1-1.36-3.5c-.19-.67-.37-1.36-.51-2l-1.51-6.93a8.59 8.59 0 0 0-1.38-3.31 8.45 8.45 0 0 0-2.26-2.17 9.23 9.23 0 0 0-2.8-1.23 12 12 0 0 0-3-.39Zm21-17.54a13 13 0 0 0-.42-3.38 6.16 6.16 0 0 0-1.47-2.66 7.17 7.17 0 0 0-2.84-1.73 13.61 13.61 0 0 0-4.48-.63H171V94.4h11.14a14.62 14.62 0 0 0 4.59-.63 7.87 7.87 0 0 0 3.05-1.77 6.87 6.87 0 0 0 1.72-2.73 10.88 10.88 0 0 0 .54-3.52Z",
    style: {
      fill: "url(#b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#c)"
    },
    d: "M45.03 0h156.96v53.37H45.03z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#d)"
    },
    d: "M0 68.46h150.94v53.37H0z"
  }))));
};

export default SvgEvolvingRegionsLogo;